import ErrorIcon from "@mui/icons-material/Error";
import { emptys } from "../data/main";
import { colorsList } from "../data/colorsList";

export default function WarningIconAlert(props) {
  const { text = "", style = {}, fontSize = 40, onClick = null } = props;
  return (
    !emptys.includes(text) &&
    text.length > 0 && (
      <div style={{ position: "relative", ...style }} onClick={onClick}>
        <div
          style={{
            backgroundColor: colorsList.darkGrey,
            width: fontSize - 4,
            height: fontSize - 4,
            borderRadius: (fontSize - 4) / 2,
          }}
        />
        <div
          style={{
            position: "absolute",
            left: 10,
            top: 10,
            backgroundColor: colorsList.black,
            width: fontSize / 2,
            height: fontSize / 2,
          }}
        />
        <ErrorIcon
          style={{
            position: "absolute",
            left: -2,
            top: -2,
            color: colorsList.yellow,
            fontSize,
          }}
        />
      </div>
    )
  );
}
